import _ from 'lodash'
import React from 'react'
import Parser from 'html-react-parser'
import ReactDOMServer from 'react-dom/server'

const REGEX_HASHTAG = /(?:^|\s)(?:#)([a-zA-Z\d_-]+)/gmu

export const extractHashtags = (source: string): string[] => {
  let match: RegExpExecArray | null
  const matches: string[] = []
  const re = new RegExp(REGEX_HASHTAG.source, REGEX_HASHTAG.flags)
  while ((match = re.exec(source))) {
    matches.push(match[1])
  }
  return matches
}

interface ProcessorProps {
  match: string
  hashtag: string
}

export const replaceHashtags = (
  source: string,
  Processor: React.ComponentType<ProcessorProps>,
): ReturnType<typeof Parser> => {
  return Parser(
    _.replace(source, REGEX_HASHTAG, (match: string, hashtag: string) => {
      return ReactDOMServer.renderToStaticMarkup(<Processor match={match} hashtag={hashtag} />)
    }),
  )
}
